var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('az-bpm-action',{staticClass:"bpm-action-adesao",attrs:{"after-action":_vm.actionAfterBpm,"before-action":_vm.tratarParametros,"business-key":_vm.businessKey,"button-attrs":{
		claim: {
			class: _vm.getClassButton('claim', ("text-none order-0 text-uppercase " + _vm.botaoClasse)),
			outlined: true,
		},
		unclaim: {
			class: _vm.getClassButton(
				'unclaim',
				("text-none order-1 ms-3 text-uppercase v-btn--width-auto " + _vm.botaoClasse)
			),
			text: true,
		},
		complete: {
			class: _vm.getClassButton(
				'complete',
				("text-none order-0 text-uppercase " + _vm.botaoClasse + " " + (_vm.temProximaTask ? 'd-flex' : 'd-none'))
			),
			outlined: true,
		},
		uncomplete: {
			class: _vm.getClassButton('uncomplete', ("text-none order-1 ms-3 text-uppercase " + _vm.botaoClasse)),
			text: true,
		},
	},"process-key":_vm.process_key},scopedSlots:_vm._u([{key:"claim",fn:function(ref){
	var button = ref.button;
return [(false)?_c('span',[_vm._v(_vm._s(button.label))]):_vm._e()]}},{key:"unclaim",fn:function(ref){
	var button = ref.button;
return [_c('icone-tooltip',{attrs:{"tamanho":"auto","icone":"mdi-undo-variant","texto":button.label,"cor":"white"}})]}},{key:"uncomplete",fn:function(ref){
	var button = ref.button;
return [_c('icone-tooltip',{attrs:{"tamanho":"auto","icone":"mdi-undo-variant","texto":button.label,"cor":"white"}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }